module.exports = __webpack_public_path__ + "static/img/short09.2a2757b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short09.png
// module id = xWiG
// module chunks = 0